import { useMemo } from 'react';

import { Field } from '~/evifields/src/types/Field';
import { FieldId } from '~/evifields/src/types/FieldId';
import { Filter } from '~/evifields/src/types/Filter';
import { api } from '~/redux/api/createApi';

export function usePinnedFilters(fields: Record<FieldId, Field> = {}) {
  const [getPinnedFilters, getPinnedFiltersResult] =
    api.endpoints.getPinnedFilters.useLazyQuery();
  const {
    data: serverPinnedFilters,
    isFetching,
    isSuccess,
  } = getPinnedFiltersResult;

  const userPreferencesDefaultFilters = useMemo(() => {
    const result: Array<Filter> = [];
    if (serverPinnedFilters?.data) {
      serverPinnedFilters?.data?.forEach((filterId: string) => {
        const field = fields[filterId];
        if (field) {
          result.push({
            id: String(field.id),
            fieldId: String(field.id),
            operatorId: null,
            values: [],
          });
        }
      });
    } else {
      return undefined;
    }

    return result;
  }, [serverPinnedFilters, fields]);

  return {
    getPinnedFilters,
    result: { data: userPreferencesDefaultFilters, isFetching, isSuccess },
  };
}
